import { useMemo } from "react";
import { FILE_PREVIEW_MAX_PDF_WIDTH } from "@/constants";
import { useMeasure } from "@uidotdev/usehooks";

export const useContainerWidth = () => {
  const [containerRef, { width: containerWidth }] =
    useMeasure<HTMLDivElement>();

  const width = useMemo(() => {
    if (!containerWidth) return undefined;
    return Math.min(containerWidth, FILE_PREVIEW_MAX_PDF_WIDTH);
  }, [containerWidth]);

  return { containerRef, width };
};
